import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Role = iotsUtils.fromList(constants.acs.roles);
